/*
 *
 * App actions
 *
 */

import {
  UPDATE_AUTH_TOKEN,
  INITIAL_LOAD_FAILURE,
  AUTH_FAILURE,
  THEME,
  FETCH_TOKEN_DETAILS_REQUEST,
  FETCH_TOKEN_DETAILS_SUCCESS,
  FETCH_TOKEN_DETAILS_FAILURE
} from './constants';

export function updateAuthToken(token) {
  return {
    type: UPDATE_AUTH_TOKEN,
    token,
  };
}

export function initialLoadFailure() {
  return {
    type: INITIAL_LOAD_FAILURE,
  };
}

export function authFailure() {
  return {
    type: AUTH_FAILURE,
  };
}

export function onThemeChange(theme) {
  return {
    type: THEME,
    theme,
  };
}

export function tokenDetailsRequest() {
  return {
    type: FETCH_TOKEN_DETAILS_REQUEST,
  };
}

export function tokenDetailsSuccess(response) {
  return {
    type: FETCH_TOKEN_DETAILS_SUCCESS,
    response
  };
}

export function tokenDetailsFailure(error) {
  return {
    type: FETCH_TOKEN_DETAILS_FAILURE,
    error
  };
}
